import { render, staticRenderFns } from "./print-code.vue?vue&type=template&id=bdc8ebc8&scoped=true"
import script from "./print-code.vue?vue&type=script&lang=js"
export * from "./print-code.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc8ebc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc8ebc8')) {
      api.createRecord('bdc8ebc8', component.options)
    } else {
      api.reload('bdc8ebc8', component.options)
    }
    module.hot.accept("./print-code.vue?vue&type=template&id=bdc8ebc8&scoped=true", function () {
      api.rerender('bdc8ebc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/correspondence/task/components/components/print-code.vue"
export default component.exports